import { render, staticRenderFns } from "./DownloadGameFooter.vue?vue&type=template&id=2574658e&scoped=true"
import script from "./DownloadGameFooter.vue?vue&type=script&lang=js"
export * from "./DownloadGameFooter.vue?vue&type=script&lang=js"
import style0 from "./DownloadGameFooter.vue?vue&type=style&index=0&id=2574658e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574658e",
  null
  
)

export default component.exports